import React from 'react';

import { Routes, Navigate, Route } from 'react-router-dom';
import CoreLayout from '@client/layouts/core';
import GuestLayout from '@client/layouts/guest';
import { PAGE_ROUTES } from '@shared/routes';
import { useNewDeals } from '@client/components/mylounge/newDeals';
import { useLeavingSoon } from '@client/components/mylounge/leavingSoon/hooks/useLeavingSoon';
import { useCustomCampaignsData } from '@client/views/customCampaigns/useCustomCampaignsData';
import { getActiveFeature } from '@client/components/mylounge/campaigns/grid/context/useGridLayoutContextValue';
import { CustomCampaignsView } from '@client/views/customCampaigns/CustomCampaignsView';
import { ForYouView } from '@client/views/forYou/ForYouView';
import { getCookie } from '@client/helpers/cookie';
import MyLounge from '../views/mylounge';

import { GenericErrorPage } from '../views/genericErrorPage';

interface MakedRoutesProps {
    isLoggedIn: boolean;
}

const MakedRoutes = ({ isLoggedIn }: MakedRoutesProps) => {
    const Layout = isLoggedIn ? CoreLayout : GuestLayout;
    const { isNewDealFeatureEnabled } = useNewDeals();
    const { isLeavingSoonComponent } = useLeavingSoon();
    const isForYouFeature = getCookie('forYouFeature') === 'true'; // TODO: check octopus imlementation for forYou feature flag

    const activeFeature = getActiveFeature(isNewDealFeatureEnabled, isLeavingSoonComponent);

    const config = useCustomCampaignsData(activeFeature);
    const element = config ? <CustomCampaignsView config={config} /> : <Navigate to="/event" />;
    const forYouView = isForYouFeature ? <ForYouView /> : <Navigate to="/event" />;

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path={PAGE_ROUTES.NewDeals} element={element} />
                <Route path={PAGE_ROUTES.LeavingSoon} element={element} />
                <Route path={PAGE_ROUTES.ForYou} element={forYouView} />
                <Route path={PAGE_ROUTES.MyLounge} element={<MyLounge />} />
                <Route path={PAGE_ROUTES.ErrorPage} element={<GenericErrorPage />} />
                <Route path="*" element={<Navigate to="/event" />} />
            </Route>
        </Routes>
    );
};

export default MakedRoutes;
